exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.count-character {\r\n  font-size: 10px;\r\n  text-align: left !important;\r\n  color: #606568;\n}\n.el-select-dropdown__item {\r\n  max-width: 500px;\n}\n.el-tag.el-tag--info.el-tag--small {\r\n  word-break: break-word !important;\r\n  display: inline-table !important;\r\n  white-space: unset !important;\n}\n.el-checkbox,\r\n.el-checkbox__input {\r\n  white-space: unset !important;\n}\n.el-checkbox__label {\r\n  display: inline !important;\r\n  word-break: break-word !important;\n}\r\n\r\n\r\n", ""]);

// exports
